module.exports = __webpack_public_path__ + "img/vertical_3_1_6000.001e6f89.png";